<div
  class="applyToAllContainer"
  *ngIf="showPrompt"
  (mouseleave)="setPromptTimeout()"
  (mouseenter)="isMouseOverPrompt = true"
  [@applyToAllEnterAnimation]
>
  <span
    >Apply {{ fieldTitle }}: {{ displayValue }} to all rows?
    <button style="margin-left: 10px" mat-flat-button color="accent" (click)="confirmApplyToAll()">Apply</button>
    <button mat-button color="primary" (click)="dismissPrompt()">Dismiss</button>
  </span>
</div>
